import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BetaAccessGuard } from '@core/guards/beta-access.guard';
import { DataValidatedGuard } from '@core/guards/data-validated.guard';
import { DefaultAccessGuard } from '@core/guards/default-access.guard';
import { HasArticleInBasketGuard } from '@core/guards/has-article-in-basket.guard';
import { LoggedGuard } from '@core/guards/logged.guard';
import { NotLoggedGuard } from '@core/guards/not-logged.guard';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { DefaultLayoutComponent } from '@features/layouts/default-layout/default-layout.component';
import { NotFoundComponent } from '@features/not-found/not-found.component';
import { ALGOLIA_SERVICE_TOKEN } from '@wizbii/algolia';
import { AlgoliaWebservice } from '@wizbii/webservices';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivateChild: [DefaultAccessGuard],
    children: [
      {
        path: FeaturesRoutingEnum.Home,
        loadChildren: () => import('./old-version/home/home.module').then((module) => module.HomeModule),
        canActivate: [LoggedGuard],
      },
      {
        path: '',
        loadChildren: () => import('./helps/helps.module').then((module) => module.HelpsModule),
      },
      {
        path: FeaturesRoutingEnum.Advices,
        loadChildren: () => import('./advices/advices.module').then((module) => module.AdvicesModule),
      },
      {
        path: FeaturesRoutingEnum.HelpForm,
        loadChildren: () => import('./old-version/help-form/help-form.module').then((module) => module.HelpFormModule),
        data: { showInterserviceHeader: false },
        canActivate: [NotLoggedGuard],
      },
      {
        path: FeaturesRoutingEnum.Dashboard,
        loadChildren: () => import('./old-version/dashboard/dashboard.module').then((module) => module.DashboardModule),
        canActivate: [NotLoggedGuard],
      },
      {
        path: FeaturesRoutingEnum.Cpu,
        loadChildren: () => import('./cpu/cpu.module').then((module) => module.CpuModule),
      },
      {
        path: FeaturesRoutingEnum.Faq,
        loadChildren: () => import('./faq/faq.module').then((module) => module.FaqModule),
      },
      {
        path: FeaturesRoutingEnum.DepotForm,
        loadChildren: () =>
          import('./old-version/depot-form/depot-form.module').then((module) => module.DepotFormModule),
        data: { showInterserviceHeader: false },
        canActivate: [NotLoggedGuard],
      },
      {
        path: FeaturesRoutingEnum.Payment,
        loadChildren: () => import('./old-version/payment/payment.module').then((module) => module.PaymentModule),
        data: { showInterserviceHeader: false },
        canActivate: [NotLoggedGuard, HasArticleInBasketGuard],
      },
    ],
  },
  {
    path: FeaturesRoutingEnum.Beta,
    component: DefaultLayoutComponent,
    canActivateChild: [BetaAccessGuard],
    children: [
      {
        path: FeaturesRoutingEnum.Home,
        loadChildren: () => import('./home/home.module').then((module) => module.HomeModule),
        canActivate: [LoggedGuard],
      },
      {
        path: '',
        loadChildren: () => import('./helps/helps.module').then((module) => module.HelpsModule),
      },
      {
        path: FeaturesRoutingEnum.Advices,
        loadChildren: () => import('./advices/advices.module').then((module) => module.AdvicesModule),
      },
      {
        path: FeaturesRoutingEnum.Dashboard,
        loadChildren: () => import('./dashboard/dashboard.module').then((module) => module.DashboardModule),
        canActivate: [NotLoggedGuard],
      },
      {
        path: FeaturesRoutingEnum.HelpForm,
        loadChildren: () => import('./help-form/help-form.module').then((module) => module.HelpFormModule),
        data: { showInterserviceHeader: false },
        canActivate: [NotLoggedGuard],
      },
      {
        path: FeaturesRoutingEnum.DepotForm,
        loadChildren: () => import('./depot-form/depot-form.module').then((module) => module.DepotFormModule),
        data: { showInterserviceHeader: false },
        canActivate: [NotLoggedGuard],
      },
      {
        path: FeaturesRoutingEnum.Cpu,
        loadChildren: () => import('./cpu/cpu.module').then((module) => module.CpuModule),
      },
      {
        path: FeaturesRoutingEnum.Faq,
        loadChildren: () => import('./faq/faq.module').then((module) => module.FaqModule),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { showInterserviceHeader: false },
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  providers: [
    DataValidatedGuard,
    DefaultAccessGuard,
    BetaAccessGuard,
    TransferState,
    AlgoliaWebservice,
    {
      provide: ALGOLIA_SERVICE_TOKEN,
      useValue: {
        applicationId: environment.algolia.applicationId,
        apiKey: environment.algolia.apiKey,
        options: {},
      },
    },
  ],
})
export class FeaturesModule {}
